import { render } from "./HR Policy.vue?vue&type=template&id=72011d16&scoped=true"
const script = {}

import "./HR Policy.vue?vue&type=style&index=0&id=72011d16&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72011d16"]])

export default __exports__